import isEmpty from 'lodash/isEmpty'
import moment from 'moment'
import qs from 'query-string'

import { OIDC_CLIENT_ID, OIDC_ISSUER } from './env'

export const isOutsideIframe = () => window.top === window.self

export const redirectToLogin = () => {
  window.location = getLoginPageUrl()
  return null
}

export const refreshToken = () => {
  if (localStorage.getItem('tokenRefreshAttempted') === 'true') {
    removeToken()
    window.location = getLoginPageUrl()
  }

  if (isTokenExpiringSoon()) {
    const rootIframe = document.getElementById('root-iframe')
    rootIframe && (rootIframe.src = getLoginPageUrl(true))
    localStorage.setItem('tokenRefreshAttempted', 'true')
  }
}

export const isTokenExpiringSoon = () => {
  const expDateTime = moment(localStorage.getItem('atexp') * 1000)
  return expDateTime.diff(moment(), 'minutes') < 5
}

export const removeToken = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('atexp')
}

export const getLoginPageUrl = (prompt = false) => {
  const search = {
    response_type: 'token',
    client_id: OIDC_CLIENT_ID,
    redirect_uri: `${window.location.origin}/oauth/callback`,
  }

  if (prompt) {
    search.prompt = 'none'
  }

  const url = new URL(OIDC_ISSUER)
  url.pathname = '/oauth/authorize'
  url.search = qs.stringify(search)

  return url
}

export const logOutAndRedirect = () => {
  removeToken()
  if (navigator.userAgent.toLowerCase().indexOf('safari') === -1) {
    document.getElementById('root-iframe').src = getLogOutUrl()
  } else {
    const popupWindow = window.open(
      getLogOutUrl(),
      'popUpWindow',
      'height=1,width=1,left=0,top=0,resizable=no,scrollbars=no,toolbar=no,menubar=no,status=no',
    )
    setTimeout(() => {
      popupWindow.close()
      window.location.href = '/login'
    }, 3000)
  }
}

export const getLogOutUrl = () => `${OIDC_ISSUER}/oauth/rp_logout`

export const isAuth = () => !isEmpty(getToken()) && !isTokenExpiringSoon()

export const getToken = () => localStorage.getItem('token')

export const setToken = (token, expDate) => {
  localStorage.setItem('token', token)
  localStorage.setItem('atexp', expDate)
  localStorage.setItem('tokenRefreshAttempted', 'false')
}
